import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthserviceService {

  constructor() { }
  ObjSession:any; 
  token :any;
  public getToken(): string {
    
    this.ObjSession = JSON.parse(localStorage.getItem("Session"));
    if(this.ObjSession!=null){

      this.token= this.ObjSession.access_token;
    }
    else{
      this.token="";
    }
    return this.token
  }
  
}

